export const featureProductsKeys = {
  all: ["feature-products"] as const,
  list: () => [...featureProductsKeys.all, "list"] as const,
  byProduct: (productId: string) => [...featureProductsKeys.all, "by-product", productId] as const,
  byFeature: (featureId: string) => [...featureProductsKeys.all, "by-feature", featureId] as const,
};
